// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application input:not([type=button]):not([type=submit]),textarea{border:none;border-radius:0!important;background-color:unset!important;font-size:medium!important}", ""]);
// Exports
module.exports = exports;
